<div class="user-layout">
  <div class="user-container">
    <div class="user-header">
      {{ 'profile.myProfile' | translate }}
    </div>

    <div class="user-buttons">
      <div class="user-button-padding">
        <libero-button routerLink="/documents" label="{{ 'profile.documents' | translate }}" btnClasses="btn--primary btn--small"></libero-button>
      </div>
      <div class="user-button-padding">
        <libero-button routerLink="/videos" label="{{ 'profile.videos' | translate }}" btnClasses="btn--primary btn--small"></libero-button>
      </div>
    </div>
    @if (!preloaders.userData) {
      @if (!userData) {
        <div class="no-data-container">
          {{ 'global.error.noData' | translate }}
        </div>
      } @else {
        <div class="row g-0 g-md-4 side-padding">
          <div class="col-12 col-md-6">
            <div class="dropdown-margin">
              <libero-custom-content-dropdown header="{{ 'profile.contactInformation' | translate }}">
                <div class="row">
                  <div class="col-4 col-sm-3 dropdown-label">
                    {{ 'profile.phone' | translate }}
                  </div>
                  <div class="col-8 col-sm-9 dropdown-value" data-cy="user-data-phone">
                    @if (!userData!.phoneNumber) {
                      {{ 'profile.missingPhone' | translate }}
                    } @else {
                      {{ userData!.phoneNumber }}
                    }
                  </div>
                  <div class="col-4 col-sm-3 dropdown-label">
                    {{ 'profile.e-mail' | translate }}
                  </div>
                  <div class="col-8 col-sm-9 dropdown-value" data-cy="user-data-email">
                    @if (!userData!.email) {
                      {{ 'profile.missingEmail' | translate }}
                    } @else {
                      {{ userData!.email }}
                    }
                  </div>
                </div>
              </libero-custom-content-dropdown>
            </div>
            <div class="dropdown-margin">
              <libero-custom-content-dropdown header="{{ 'profile.investmentProfile' | translate }}" data-cy="questionaire-dropdown">
                <div class="risk-container">
                  <div class="risk-label">
                    {{ 'profile.maxRisk' | translate }}
                  </div>
                  <div class="slidecontainer">
                    <input #slider disabled type="range" min="1" max="{{ sliderMax }}" value="{{ userData!.maxRiskScore }}" class="slider">
                  </div>
                  <div class="risk-bar mt-1">
                    @for (riskLevel of riskLevels; track riskLevel) {
                      <div class="legend" [ngClass]="{ 'legend--active': riskLevel === userData!.maxRiskScore }">
                        {{ riskLevel }}
                      </div>
                    }
                  </div>
                </div>
                <div class="execution-strategy-info" data-cy="investment-profile-text">
                  <svg-icon src="assets/icons/info-circled.svg" [svgStyle]="{ 'width.px':26 }"></svg-icon>
                  {{ 'profile.riskProfileText.part1' | translate }}
                  @for (idx of getPortfolioTypesIdxsByMax(userData!.maxRiskScore); track idx) {
                    <!-- forms list of types, determines whether to add comma, conjuction for -and/a- or empty space  -->
                    {{ 'profile.portfolioTypes.' + idx | translate }}{{ portfolioTypesSeparator(idx) }}
                  }
                  @if (userData!.managementType === 'EXECUTION_ONLY') {
                    {{ 'profile.riskProfileText.part2Allowed' | translate }}
                  } @else {
                    {{ 'profile.riskProfileText.part2NotAllowed' | translate }}
                  }
                </div>
                @if (userData!.managementType === 'EXECUTION_ONLY') {
                  <div
                    class="instruments-categories-list"
                    data-cy="profile-allowed-instrument-categories">
                    @for (instrumentCategory of userInstrumentCategories; track instrumentCategory) {
                      <div
                        class="instrument-category"
                        data-cy="profile-allowed-instrument-category">
                        <span>{{ instrumentCategory }}</span>
                      </div>
                    }
                  </div>
                }
                <div class="investment-profile-buttons mt-4">
                  <div class="expired-checkbox-container">
                    <div class="checkbox-icon">
                      <label class="container container--disabled" for="updated-checkbox">
                        <input id="updated-checkbox" type="checkbox" name="updated-checkbox" [checked]="!userData!.investmentQuestionnaire.expired" disabled="true">
                        <span class="checkmark checkmark--big"></span>
                      </label>
                    </div>
                    <p><strong>
                      @if (!userData!.investmentQuestionnaire.expired) {
                        {{ 'profile.expiredCheckbox.expiredFalse' | translate }} {{ userData!.investmentQuestionnaire.date | date: 'd. M. y' }}
                      } @else {
                        {{ 'profile.expiredCheckbox.expiredTrue' | translate }}
                      }
                    </strong></p>
                  </div>
                  <libero-button
                    data-cy="open-questionaire-btn"
                    (click)="goToInvestmentQuestionaireForm()"
                    label="{{ 'profile.questionaireAgain' | translate }}"
                    [btnClasses]="'btn--primary btn--heading btn--questionaire-redirect' + (iosWorkaroundService.isIosBrowser ? ' ios--size' : '')"
                    [buttonDisabled]="!userData!.investmentQuestionnaire.updatable"
                    [tooltipUseTranslateKey]="false"
                    [disabledTooltipText]="('global.tooltips.questionaireAgainDisabled' | translate) + (userData!.investmentQuestionnaire.cooldownDate | date: 'd. M. y')"
                  ></libero-button>
                </div>
              </libero-custom-content-dropdown>
            </div>

            @if(displayOpfTransferBtn()) {
              <div class="dropdown-margin">
                <libero-custom-content-dropdown header="{{ 'profile.feesConfirmDropdown.header' | translate }}">
                  @if (preloaders.additions) {
                    <libero-preload-spinner></libero-preload-spinner>
                  } @else {
                    <p class="text-center">{{ 'profile.feesConfirmDropdown.desc' | translate }}</p>
                    <div class="text-center">
                      <libero-button
                        data-cy="change-execution-only-btn"
                        (click)="!additionsDisabled.feesConfigProcessing && modalService.openProfileFeesTransferConfirmModal()"
                        label="{{ 'profile.feesConfirmDropdown.btn' | translate }}"
                        [btnClasses]="'btn--primary btn--heading btn--client-addition'"
                        [tooltipUseTranslateKey]="false"
                        [buttonDisabled]="!!additionsDisabled.feesConfigProcessing"
                        [disabledTooltipText]="additionsDisabled.feesConfigProcessing ? (('profile.clientAdditions.disabledReasons.' + additionsDisabled.feesConfigProcessing) | translate) : null"
                      ></libero-button>
                    </div>
                  }
                </libero-custom-content-dropdown>
              </div>
            }
            <div class="dropdown-margin">
              <libero-custom-content-dropdown header="{{ 'profile.clientAdditions.headerExecutionOnlySwitch' | translate }}">
                @if (preloaders.additions) {
                  <libero-preload-spinner></libero-preload-spinner>
                } @else {
                  <p class="text-center">{{ 'profile.clientAdditions.descriptionExecutionOnlySwitch' | translate }}</p>
                  <div class="text-center">
                    <libero-button
                      data-cy="change-execution-only-btn"
                      (click)="!additionsDisabled.executionOnlySwitch && modalService.openExecutionSwitchConfirm()"
                      label="{{ 'profile.clientAdditions.buttonLabelExecutionOnlySwitch' | translate }}"
                      [btnClasses]="'btn--primary btn--heading btn--client-addition'"
                      [tooltipUseTranslateKey]="false"
                      [buttonDisabled]="!!additionsDisabled.executionOnlySwitch"
                      [disabledTooltipText]="additionsDisabled.executionOnlySwitch ? (('profile.clientAdditions.disabledReasons.' + additionsDisabled.executionOnlySwitch) | translate) : null"
                    ></libero-button>
                  </div>
                }
              </libero-custom-content-dropdown>
            </div>
            <div class="dropdown-margin">
              <libero-custom-content-dropdown header="{{ 'profile.clientAdditions.headerPortfoliosMigrate' | translate }}">
                @if (preloaders.additions) {
                  <libero-preload-spinner></libero-preload-spinner>
                } @else {
                  <p class="text-center">{{ 'profile.clientAdditions.descriptionPortfoliosMigrate' | translate }}</p>
                  <div class="text-center">
                    <libero-button
                      data-cy="change-client-btn"
                      (click)="!additionsDisabled.portfoliosMigrate && modalService.openPortfoliosMigrateConfirm()"
                      label="{{ 'profile.clientAdditions.buttonLabelPortfoliosMigrate' | translate }}"
                      [btnClasses]="'btn--primary btn--heading btn--client-addition'"
                      [tooltipUseTranslateKey]="false"
                      [buttonDisabled]="!!additionsDisabled.portfoliosMigrate"
                      [disabledTooltipText]="additionsDisabled.portfoliosMigrate ? (('profile.clientAdditions.disabledReasons.' + additionsDisabled.portfoliosMigrate) | translate) : null"
                    ></libero-button>
                  </div>
                }
              </libero-custom-content-dropdown>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="dropdown-margin">
              <libero-custom-content-dropdown header="{{ 'profile.personalData' | translate }}">
                <div class="row">
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.name' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userData!.firstName }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.surname' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userData!.lastName }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.title' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userData!.titleBefore }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.birthdate' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userData!.birthDate | date:'d. M. y' }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.nationality' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userData!.citizenShipCode }}
                  </div>
                  <div class="col-12 paragraph-header">
                    {{ 'profile.permanentResidence' | translate }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.street' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userDomicileAddress.streetName }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.descriptiveNumber' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userDomicileAddress.descriptionNo }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.orientationNumber' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userDomicileAddress.orientationNo }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.city' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userDomicileAddress.city }}
                  </div>
                  <div class="col-6 col-sm-4 dropdown-label">
                    {{ 'profile.zipCode' | translate }}
                  </div>
                  <div class="col-6 col-sm-8 dropdown-value">
                    {{ userDomicileAddress.zip }}
                  </div>
                </div>
              </libero-custom-content-dropdown>
            </div>
            <div class="dropdown-margin">
              <libero-custom-content-dropdown header="{{ 'profile.languageEtfInfo.header' | translate }}">
                <div
                  class="language-etf-info"
                  [ngClass]="{ 'language-etf-info--clickable': !userData!.canReadEnglish }"
                  (click)="!userData!.canReadEnglish && openConfirmEtfUpdate()"
                  (keydown.space)="!userData!.canReadEnglish && openConfirmEtfUpdate()"
                  (keydown.enter)="!userData!.canReadEnglish && openConfirmEtfUpdate()"
                  tabindex="0"
                  data-cy="profile-etf-info"
                  >
                  <div class="etf-checkbox-container">
                    <label class="container" for="etf-checkbox" [ngClass]="{ 'container--disabled': userData!.canReadEnglish }">
                      <input id="etf-checkbox" type="checkbox" name="etf-checkbox" [checked]="userData!.canReadEnglish" disabled="true">
                      <span class="checkmark checkmark--big"></span>
                    </label>
                  </div>
                  <div>
                    <p>{{ 'profile.languageEtfInfo.checkboxText1' | translate }}</p>
                    <p>{{ 'profile.languageEtfInfo.checkboxText2' | translate }}</p>
                  </div>
                </div>
              </libero-custom-content-dropdown>
            </div>
          </div>
        </div>
      }
    } @else {
      <libero-preload-spinner></libero-preload-spinner>
    }

  </div>
</div>
